import { render, staticRenderFns } from "./CommercegateDeposit.vue?vue&type=template&id=af7a0936&scoped=true"
import script from "./CommercegateDeposit.vue?vue&type=script&lang=js"
export * from "./CommercegateDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a0936",
  null
  
)

export default component.exports